import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { SettleLawsuitKind } from "../../../define/SettleLawsuitKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitModelLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	btnStart: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnAd: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelNormalCount: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelNormalHint: cc.Label = null;

    private bDownTime = false;
    private timeCount = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.addLayerTouchEvent();

        this.initLayer();
    }

    initLayer() {
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let todaySettleLawsuitUseCount = gameData.todaySettleLawsuitUseCount;
        let maxCount = SettleLawsuitKind.GeneralValue.MAX_USE_COUNT;
        if (todaySettleLawsuitUseCount >= maxCount) {
            this.btnStart.active = false;
            this.btnAd.active = true;
            this.labelNormalHint.node.active = true;
            this.labelNormalCount.node.active = false;
            this.refreshDownTime();
            this.bDownTime = true;
        } else {
            this.labelNormalHint.node.active = false;
            this.labelNormalCount.node.active = true;
            this.btnStart.active = true;
            this.btnAd.active = false;
            this.labelNormalCount.string = `今日剩余断案次数(${todaySettleLawsuitUseCount}/${maxCount})`;
        }
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.GOVERNMENT);
        utilsView.enterLayerDispose(UIKind.UILayerTag.GOVERNMENT, this.node);
    }

    refreshDownTime() {
        let curTime = Date.now();
        let nextTime = data_control.getOtherDayStartTime(curTime);
        let spaceT = nextTime - curTime;
        let strT = data_control.getTimeFormatClock(Math.floor(spaceT/1000));
        this.labelNormalHint.string = '距离下次断案' + strT;
    }

    onClickLegalCase(e, bNoPlay: boolean = false) {
        if (!bNoPlay) {
            O1HD.getManagers().soundMgr.playSound("anNiu").then();
        }
        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_CONFIG);
        if (!csvInfo) {
            console.error(`数据未找到`);
            return;
        }

        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        gameManager.setGameData({todaySettleLawsuitUseCount: gameData.todaySettleLawsuitUseCount + 1});

        this.initLayer();

        let title = csvInfo.title;
        // 概率
        let probability_basic = Number(csvInfo.probability_basic[title.value]);
        let probability_main = Number(csvInfo.probability_main[title.value]);
        let probability_special = Number(csvInfo.probability_special[title.value]);

        let randomNum = data_control.randomNumInt(
            1
            , probability_basic + probability_main + probability_special
        );
        let prefabFile: FileKind.PrefabFileInfo = null;
        let modelCsvName = '';

        //// 测试代码
        // randomNum = probability_basic;
        
        if (randomNum <= probability_basic) {
            // 初级模式
            prefabFile = FileKind.PrefabFilePath.SettleLawsuitPrimaryLayer;
            modelCsvName = CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY;
        } else if (randomNum <= probability_basic + probability_main) {
            // 主要模式
            prefabFile = FileKind.PrefabFilePath.SettleLawsuitMainLayer;
            modelCsvName = CsvFileKind.CsvFile.LEGAL_CASE_MAIN;
        } else {
            // 特殊模式
            prefabFile = FileKind.PrefabFilePath.SettleLawsuitSpecialLayer;
            modelCsvName = CsvFileKind.CsvFile.LEGAL_CASE_SPECIAL;
        }

        
        let caseId = this.getLegalCaseRandomId(modelCsvName);
        if (!caseId) {
            return;
        } 

        utilsView.openPopupLayerTwo(
            prefabFile
            , null
            , {id: caseId}
        );
    }

    /**
     * 获得案件随机id
     * @param csvName 
     * @returns 
     */
    getLegalCaseRandomId(csvName: string) {
        return CsvDataManage.instance.getCsvRandomId(csvName);
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.onClickLegalCase(null, true);
        },()=>{

        },null,"断案观看广告增加次数")
    }
    
    protected update(dt: number): void {
        if (!this.bDownTime) {
            return;
        }
        this.timeCount += dt;
        if (this.timeCount < 1) {
            return;
        }
        this.timeCount = 0;

        this.refreshDownTime();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.GOVERNMENT);
    }
}
